import { render, staticRenderFns } from "./WindowTypeBlock.vue?vue&type=template&id=378ef9d0&"
import script from "./WindowTypeBlock.vue?vue&type=script&lang=js&"
export * from "./WindowTypeBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports